<template>
  <div class="container-fluid mt-3">
    <b-row>
      <b-col> <h1 >{{planTypeText}} expirou!</h1> </b-col>
    </b-row>
    <b-row>
      <b-col>
        <subscribe @stored="$router.push('/dashboard')" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Subscribe from "./Subscribe.vue";
export default {
  components: { Subscribe },

  mounted() {
    this.$store.commit("pageHasLoaded");
  },

computed: {
      lastSubscription() {
      return this.$store.state.active_subscription;
    },

    isOnFreePlan() {
      return this.lastSubscription.plan_id == 1;
    },
    planTypeText() {
      return this.isOnFreePlan ? "Seu período de teste " : "Sua Assinatura";
    },

},

};
</script>

<style>
</style>